import { CustomerSatisfactionBanner, FeedbackMediaType } from "@amzn/stencil-react-components/customer-satisfaction";
import { RenderModalFunctionParams, WithModal } from "@amzn/stencil-react-components/modal";
import { getString } from "common/uistringlabels/uiStringUtils";
import React, { useCallback, useMemo, useRef, useState } from "react";
import { FC } from "react";

import { CustomerFeedbackModal } from "../CustomerFeedbackModal";

const IMAGE_PATH = "/img/cfm-rocket.svg";

interface CustomerFeedbackBannerProps {
  touchpoint: string;
}

export const CustomerFeedbackBanner: FC<CustomerFeedbackBannerProps> = ({ touchpoint }) => {
  const [submittedRating, setSubmittedRating] = useState<number | undefined>(undefined);
  const didSubmitRef = useRef(false);
  const [bannerKey, setBannerKey] = useState(0);

  const mediaProps = useMemo(
    () => ({
      media: {
        altText: getString("customerFeedback.banner.imageAltText"),
        src: IMAGE_PATH,
        type: FeedbackMediaType.IMAGE,
      },
    }),
    []
  );

  const renderModal = useCallback(
    ({ close }: RenderModalFunctionParams) => {
      const handleClose = () => {
        if (!didSubmitRef.current) {
          setSubmittedRating(undefined);
        }
        setBannerKey((k) => k + 1);
        didSubmitRef.current = false;
        close();
      };

      return (
        <CustomerFeedbackModal
          touchpoint={touchpoint}
          analyticsEventPrefix="cfm-banner"
          close={handleClose}
          onSubmitSuccess={(ratingIndex: number) => {
            didSubmitRef.current = true;
            setSubmittedRating(ratingIndex);
          }}
        />
      );
    },
    [touchpoint]
  );

  return (
    <WithModal renderModal={renderModal}>
      {({ open }: { open: () => void }) => (
        <CustomerSatisfactionBanner
          key={bannerKey}
          mediaProps={mediaProps}
          ratingProps={{
            onChange: (ratingIndex: number) => {
              setSubmittedRating(undefined);
              setBannerKey((k) => k + 1);
              sessionStorage.setItem(`feedback-score-${touchpoint}`, String(ratingIndex));
              open();
            },
            options: getString("customerFeedback.banner.ratingOptions") as unknown as string[],
            value: submittedRating,
          }}
          subtitleText={getString("customerFeedback.banner.voteAgainMessage")}
          titleText={getString("customerFeedback.banner.titleText")}
          shouldShowFeedbackModal={false}
          shouldShowOutroModal={false}
        />
      )}
    </WithModal>
  );
};
